import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { recordVisit } from '../lib/visitTracking';

export function useVisitTracking() {
  const { pathname } = useLocation();
  const started = useRef(false);
  useEffect(() => {
    if (pathname.startsWith('/auth/') || started.current) return;
    started.current = true;
    void recordVisit();
  }, [pathname]);
}